import httpRda from "../http-rda";

export default async function enrollmentAuthorizationCheck(enrollmentId) {
  const result = httpRda
    .get(`/enrollments/${enrollmentId}/authorized`)
    .then((res) => res.data.status);
  return result;
}
